// components
import { Navbar1 } from '../../../components/navbars';
import BackToTop from '../../../components/BackToTop';
import { Footer1 } from '../../../components/footer';
import Hero from './Hero';
// dummy data
import { benefits, gallery, vacancies, features } from './data';
import Features from './Features';

import Overview from './Overview';


const Career = () => {
    return (
        <>
            {/* <div className=" position-relative"> */}
            {/* <Navbar1
                    hideSearch
                    fixedWidth
                    navClass="navbar-light zindex-10"
                    buttonClass="btn-outline-secondary btn-sm"
                /> */}
            {/* <Overview /> */}
            <Hero />
            <Features features={features} />
            <BackToTop />
        </>
    );
};

export default Career;
